import { render, staticRenderFns } from "./TrademarkSearchOwnerList.vue?vue&type=template&id=52fc02b5&"
import script from "./TrademarkSearchOwnerList.vue?vue&type=script&lang=js&"
export * from "./TrademarkSearchOwnerList.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkSearchOwnerList.vue?vue&type=style&index=0&id=52fc02b5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports